import { z } from 'zod';
import { weakPasswordReason } from './password-strength.js';
/** Password policy: 12–128 chars with a letter and a digit, and not an easily guessed pattern (see password-strength). */
export const passwordSchema = z
    .string()
    .min(12, 'Password must be at least 12 characters')
    .max(128, 'Password must be at most 128 characters')
    .regex(/[A-Za-z]/, 'Password must contain a letter')
    .regex(/\d/, 'Password must contain a digit')
    .superRefine((value, ctx) => {
    const reason = weakPasswordReason(value);
    if (reason)
        ctx.addIssue({ code: 'custom', message: reason });
});
export const emailSchema = z.string().trim().toLowerCase().email().max(254);
export const usernameSchema = z
    .string()
    .trim()
    .toLowerCase()
    .regex(/^[a-z0-9._-]{3,50}$/, 'Username must be 3-50 chars: a-z, 0-9, ".", "_", "-"');
export const loginSchema = z.object({
    /** Email or username. */
    identifier: z.string().trim().min(1).max(254),
    password: z.string().min(1).max(128),
});
export const forgotPasswordSchema = z.object({ email: emailSchema });
export const resetPasswordSchema = z.object({
    token: z.string().min(20).max(200),
    password: passwordSchema,
});
export const verifyEmailSchema = z.object({ token: z.string().min(20).max(200) });
export const changePasswordSchema = z.object({
    currentPassword: z.string().min(1).max(128),
    newPassword: passwordSchema,
});
// ------------------------------------------------------------- second step (TOTP)
const totpCode = z
    .string()
    .trim()
    .regex(/^\d{6}$/, 'Enter the 6-digit code');
const recoveryCode = z
    .string()
    .trim()
    .min(10)
    .max(14)
    .regex(/^[A-Za-z0-9][A-Za-z0-9 -]*[A-Za-z0-9]$/, 'Enter a recovery code like ABCDE-23456');
const exactlyOneProof = (value) => (value.code === undefined) !== (value.recoveryCode === undefined);
const proofMessage = { message: 'Give either the 6-digit code or a recovery code', path: ['code'] };
export const mfaVerifySchema = z
    .object({
    mfaToken: z.string().min(20).max(2000),
    code: totpCode.optional(),
    recoveryCode: recoveryCode.optional(),
})
    .refine(exactlyOneProof, proofMessage);
/** Starting set-up asks for the password again, so a stolen session cannot enrol an attacker's authenticator. */
export const mfaSetupSchema = z.object({ password: z.string().min(1).max(128) });
export const mfaEnableSchema = z.object({ code: totpCode });
export const mfaDisableSchema = z
    .object({
    password: z.string().min(1).max(128),
    code: totpCode.optional(),
    recoveryCode: recoveryCode.optional(),
})
    .refine(exactlyOneProof, proofMessage);
export const mfaRegenerateSchema = z.object({
    password: z.string().min(1).max(128),
    code: totpCode,
});
//# sourceMappingURL=auth.js.map